/**
 * useSearch Hook — TanStack Query 搜索封装
 */

import { useQuery, keepPreviousData } from '@tanstack/react-query';
import { searchPois, searchHotels, searchAttractions, searchGuides, type SearchRequest, type SearchResult, type PoiSearchDoc, type HotelSearchDoc, type GuideDoc } from '@/infrastructure/api/search';

export function useSearchPois(params: SearchRequest, enabled = true) {
  return useQuery<SearchResult<PoiSearchDoc>>({
    queryKey: ['search', 'pois', params],
    queryFn: () => searchPois(params),
    enabled: enabled && (!!params.query || !!params.city),
    placeholderData: keepPreviousData,
    staleTime: 5 * 60 * 1000, // 5 min
  });
}

export function useSearchHotels(params: SearchRequest, enabled = true) {
  return useQuery<SearchResult<HotelSearchDoc>>({
    queryKey: ['search', 'hotels', params],
    queryFn: () => searchHotels(params),
    enabled: enabled && (!!params.query || !!params.city),
    placeholderData: keepPreviousData,
    staleTime: 5 * 60 * 1000,
  });
}

export function useSearchAttractions(params: SearchRequest, enabled = true) {
  return useQuery<SearchResult<PoiSearchDoc>>({
    queryKey: ['search', 'attractions', params],
    queryFn: () => searchAttractions(params),
    enabled: enabled && (!!params.query || !!params.city),
    placeholderData: keepPreviousData,
    staleTime: 5 * 60 * 1000,
  });
}

export function useSearchGuides(params: SearchRequest, enabled = true) {
  return useQuery<SearchResult<GuideDoc>>({
    queryKey: ['search', 'guides', params],
    queryFn: () => searchGuides(params),
    enabled: enabled && (!!params.query || !!params.city),
    placeholderData: keepPreviousData,
    staleTime: 10 * 60 * 1000,
  });
}
